'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import classNames from 'classnames';
import MainSidebarContainer from 'DesignEditorsUI/containers/customWidgetEditor/MainSidebar';
import FieldEditSidebarContainer from 'DesignEditorsUI/containers/customWidgetEditor/FieldEditSidebar';
import IconSidebarContainer from 'DesignEditorsUI/containers/customWidgetEditor/IconSidebar';
const MAIN_VIEW_ID = 'main';
const FIELD_EDIT_VIEW_ID = 'field-edit';
const ICON_VIEW_ID = 'icon';
export default class Sidebar extends Component {
  get activeViewId() {
    const {
      isSelectingIcon,
      selectedField
    } = this.props;

    if (isSelectingIcon) {
      return ICON_VIEW_ID;
    } else if (selectedField.field) {
      return FIELD_EDIT_VIEW_ID;
    }

    return MAIN_VIEW_ID;
  }

  renderContent() {
    const {
      customWidgetId,
      revisionId
    } = this.props;

    switch (this.activeViewId) {
      case ICON_VIEW_ID:
        return /*#__PURE__*/_jsx(IconSidebarContainer, {
          customWidgetId: customWidgetId,
          revisionId: revisionId
        });

      case FIELD_EDIT_VIEW_ID:
        return /*#__PURE__*/_jsx(FieldEditSidebarContainer, {
          customWidgetId: customWidgetId,
          revisionId: revisionId
        });

      default:
        return /*#__PURE__*/_jsx(MainSidebarContainer, {
          customWidgetId: customWidgetId,
          revisionId: revisionId
        });
    }
  }

  render() {
    const className = classNames('custom-widget-editor-sidebar', this.activeViewId === MAIN_VIEW_ID && 'main-sidebar', this.activeViewId === FIELD_EDIT_VIEW_ID && 'field-edit-sidebar', this.activeViewId === ICON_VIEW_ID && 'icon-sidebar');
    return /*#__PURE__*/_jsx("div", {
      className: className,
      children: this.renderContent()
    });
  }

}
Sidebar.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  isSelectingIcon: PropTypes.bool.isRequired,
  selectedField: PropTypes.object.isRequired,
  revisionId: PropTypes.number
};